/* eslint-disable no-nested-ternary */
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { bem, classNameWithModifiers as withMods } from 'helpers/class-name';
import LoadingDots from 'components/LoadingDots';
import _isFunction from 'lodash/isFunction';
import Isvg from 'react-inlinesvg';
import { ICONS } from 'constants/icons';
import './Card.scss';

const { block, element } = bem('card');

const Card = forwardRef(
  (
    {
      as: Component = 'div',
      centered = false,
      collapse = false,
      flush = false,
      loading = false,
      className,
      children,
      closable = false,
      onClose,
      closeIconSolid = false,
      ...rest
    },
    ref
  ) => {
    const mods = {
      centered: centered || loading,
      collapse,
      flush,
    };

    // don't render an empty card
    if (!children && !loading) return null;

    return (
      <Component ref={ref} className={block(mods, className)} {...rest}>
        {closable ? (
          <Isvg
            className={withMods(element('close-button'), { solid: closeIconSolid })}
            src={closeIconSolid ? ICONS.crossInCircle : ICONS.cross}
            onClick={onClose}
          />
        ) : null}
        {loading ? <LoadingDots /> : _isFunction(children) ? children() : children}
      </Component>
    );
  }
);

Card.propTypes = {
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.elementType]),
  centered: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  className: PropTypes.string,
  collapse: PropTypes.bool,
  flush: PropTypes.bool,
  loading: PropTypes.bool,
  closable: PropTypes.bool,
  onClose: PropTypes.func,
  closeIconSolid: PropTypes.bool,
};

Card.defaultProps = {
  onClose: () => {},
};

Card.displayName = 'Card';

export default Card;
